<template>
	<div class="flex flex-col gap-[16px] bg-white rounded-[12px] overflow-hidden">
		<NuxtLink :to="formatLink(slug)">
			<img
				class="w-full md:h-[306px] md:object-cover"
				width="400"
				height="306"
				:src="featured_image"
			/>
		</NuxtLink>
		<div class="intro-content">
			<div v-if="type && type === 'news'">
				<NuxtLink
					class="text-blue-500 leading-none font-semibold"
					:to="`/category/stock-news/`"
				>
					Stock News
				</NuxtLink>
			</div>
			<div>
				<NuxtLink
					v-if="category && category.name"
					class="text-blue-500 leading-none font-semibold"
					:to="`/category/${category.slug}/`"
				>
					{{ category.name }}
				</NuxtLink>
			</div>

			<NuxtLink :to="type && type === 'news' ? `/news/${slug}` : formatLink(slug)">
				<h3
					class="text-slate-900 font-bold text-[18px] lg:text-[22px] leading-tight min-h-[56px]"
					v-html="type && type === 'news' ? title : title.rendered"
				></h3>
			</NuxtLink>

			<div class="additional-info">
				<span class="items-stretch flex gap-2">
					<img
						loading="lazy"
						srcSet="https://secure.gravatar.com/avatar/ffab25dfa1b032865bcfe0a47dde563a?s=48&d=mm&r=g"
						class="aspect-square rounded-[32px] object-contain object-center w-[34px] overflow-hidden shrink-0 max-w-full"
					/>
					<a
						href="#"
						class="text-black text-sm font-medium leading-5 self-center grow whitespace-nowrap my-auto"
					>
						Tim Bohen
					</a>
				</span>

				<p
					v-if="content_read_time"
					class="text-slate-600 pl-[4px] md:pl-[8px] leading-none"
					v-html="`${content_read_time} min read`"
				></p>

				<p
					v-else
					class="text-slate-600 pl-[4px] md:pl-[8px] leading-none"
					v-html="`${calculateReadingTime(content.rendered)} min read`"
				></p>
			</div>
		</div>
	</div>
</template>

<script setup>
const { featured_media, _embedded } = defineProps([
	"featured_media",
	"_embedded",
	"slug",
	"title",
	"category",
	"modified",
	"content",
	"content_read_time",
	"type"
]);

const { hostname } = useRuntimeConfig().public;

const featured_image = computed(() => {
	if (!featured_media) {
		return "/images/block-form-bg.jpg";
	}

	if (
		featured_media &&
		_embedded &&
		featured_media.source_url &&
		!featured_media.source_url.includes("hostname")
	) {
		return featured_media.source_url;
	}
	const image =
		featured_media && featured_media.source_url
			? `${hostname}cdn-cgi/image/quality=100,format=webp,width=480/${featured_media.source_url}`
			: _embedded &&
				  _embedded["wp:featuredmedia"] &&
				  _embedded["wp:featuredmedia"][0].source_url
				? `${hostname}cdn-cgi/image/quality=100,format=webp,width=480/${_embedded["wp:featuredmedia"][0].source_url}`
				: "/images/daily-acelerator.webp";

	return image;
});
</script>

<style lang="scss" scoped>
.additional-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	// gap: 12px;
}

.intro-content {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 0 16px;
	margin-bottom: 16px;
}
</style>
